import React from 'react';

import './index.less';

import IbTypography from '../../common/IbTypography';
import IbIcon from '../../common/IbIcon';
import IbButton from '../../common/IbButton';
import { StagedAttachment } from '../types';

const MAIN_CLASS_NAME = 'message-input-attachments';
const ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__item`;
const ITEM_ICON_CLASS_NAME = `${ITEM_CLASS_NAME}__icon`;
const ITEM_NAME_CLASS_NAME = `${ITEM_CLASS_NAME}__name`;
const ITEM_STATUS_CLASS_NAME = `${ITEM_CLASS_NAME}__status`;

export interface IMessageInputAttachmentsProps {
  attachments: StagedAttachment[];
  onAttachmentReUpload?: (attachment: StagedAttachment) => void;
  onAttachmentDelete?: (attachment: StagedAttachment) => void;
}

const MessageInputAttachments: React.FC<IMessageInputAttachmentsProps> = ({
  attachments,
  onAttachmentReUpload,
  onAttachmentDelete,
}) => {
  if (!attachments.length) {
    return null;
  }

  return (
    <div className={MAIN_CLASS_NAME}>
      {attachments.map((attachment, index) => {
        const onDelete = () => onAttachmentDelete?.(attachment);
        const onReUpload = () => onAttachmentReUpload?.(attachment);

        const itemClasses = [ITEM_CLASS_NAME, `${ITEM_CLASS_NAME}_${attachment.status}`];

        return (
          <div key={index} className={itemClasses.join(' ')}>
            {attachment.status === 'uploading' ? (
              <IbIcon spin iconName="loading-four" size={16} />
            ) : (
              <IbIcon className={ITEM_ICON_CLASS_NAME} iconName="paperclip" size={16} />
            )}
            <IbTypography.Paragraph className={ITEM_NAME_CLASS_NAME} type="secondary">
              {attachment.file.name}
            </IbTypography.Paragraph>
            <div className={ITEM_STATUS_CLASS_NAME}>
              {attachment.status === 'error' && (
                <IbButton icon={<IbIcon iconName="refresh" size={16} />} type="icon" onClick={onReUpload} />
              )}
              <IbButton icon={<IbIcon iconName="close" size={16} />} type="icon" onClick={onDelete} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MessageInputAttachments;
